export default function getMetaValue(name) {
  const metaValue = document.head.querySelector(`meta[name="${name}"]`);
  return metaValue ? metaValue.getAttribute("content") : null;
}
